import moment from 'moment';
import React, { useCallback, useEffect, useState, useRef } from "react";
import CameraFilled from "@ant-design/icons/lib/icons/CameraFilled";
import { Radio, Select } from "antd";
import { Upload } from "antd";
import styled from "styled-components";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { CloseOutlined } from '@ant-design/icons';
import DatePicker, { DateObject }  from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Icon from "react-multi-date-picker/components/icon"

//Internal Imports
import { COLORS } from "../../constants/colors";
import { PreguntaTipo } from "../../enums/AllEnums";
import "./TypeInputGeneratorItem.css";
import { useForm } from "../../../contexts/form";
import ChangeCenter from '../../../moduls/Historico/HistoricoEntidadEncuestada/HistoricoEntidadAvanzada/ChangeCenter';
import LoadingButton from '../LoadingButton/LoadingButton';

interface Props {
    value: any;
    OnChange: any;
    item: any;
    children?: JSX.Element;
    inForm?: boolean;
    active?: boolean;
    answerValue: any;
    SetAnswerValue?: any;
    setActive?: React.Dispatch<React.SetStateAction<boolean>>;
    setIsLastQuestion?: React.Dispatch<React.SetStateAction<boolean>>;
    defaultValue?: any;
    isDraggable?: boolean;
}

const { Option } = Select;

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${COLORS.white_color2(1)};
    border-radius: 10px !important;
    border: 1px solid ${COLORS.black_text_color3};
    height: 4em;
    padding-left: 8px;
    width: 85%;

    label {
        color: ${props => !!props.value ? COLORS.black_text_color1 : COLORS.black_text_color3};
        font-weight: 300;
        opacity: ${props => !!props.value ? 1 : 0.5};
        font-size: 1.05em;
    }

    .group-icon {
        position: relative;
        right: -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4em;
        border-left: 1px solid ${COLORS.black_back_color5};
    }

    .icon-remove {
        background-color: ${COLORS.red_error2};
        height: 4em;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: white;
        width: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .icon-remove:active {
        opacity: 0.7;
    }

   .icon-upload .ant-upload.ant-upload-select-picture-card, .icon-upload .ant-upload-list{
        background-color: ${COLORS.blue_active};
        height: 4em;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        width: 33px;
        border: none
   }

   .icon-upload i {
       color: white;
   }

   .icon-download {

        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        background-color: ${COLORS.blue_active};
        height: 4em;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        width: 33px;
        border: none

    }

    .icon-download:active {
        opacity: 0.7;
    }

`;

const TypeInputGeneratorItem = ({ OnChange, value, item, children, inForm = true, active, setActive, setIsLastQuestion, answerValue, SetAnswerValue, defaultValue, isDraggable }: Props): JSX.Element => {
    const [question, SetQuestion] = useState<any>();
    const center = {
        lat: 18.4395826,
        lng: -69.9397404
    }
    let typeInput: JSX.Element = <></>;
    const [photoPreview, setPhotoPreview] = useState<string>('');
    const [respuestaOpciones, SetRespuestaOpciones] = useState<{ label: string, value: string }[]>([]);
    const [respuestaOpcionesMultiple, SetRespuestaOpcionesMultiple] = useState<{ label: string, value: string }[]>([]);
    const { setOptionSelected } = useForm();
    const [draggable, setDraggable] = useState(true);
    const [position, setPosition] = useState(center);
    const [showMap, setShowMap] = useState(true);
    const markerRef = useRef<any>(null);
    const [respuestaFile, SetRespuestaFile] = useState<string>('');
    const [listRespuestaFechaRangoMultiple, setListRespuestaFechaRangoMultiple] = useState<{ fechaDesde: string, fechaHasta: string }[]>([]);
    const [objectRespuestaFechaRango, setObjectRespuestaFechaRango] = useState<{ fechaDesde: string, fechaHasta: string }>({ fechaDesde: "", fechaHasta: "" });

    type DateRange = [DateObject, DateObject];
    type DateRanges = DateRange[];

    const [respuestaFecha, setRespuestaFecha] = useState<any>(null);
    const [respuestaFechaRangoMultiple, setRespuestaFechaRangoMultiple] = useState<DateRanges>([]);
    const [respuestaFechaRango, setRespuestaFechaRango] = useState<DateRange>();

    const [minFecha, setMinFecha] = useState<any>(null);
    const [maxFecha, setMaxFecha] = useState<any>(null);    

    const eventHandlers =
    {
        dragend() {
            const marker = markerRef.current
            if (marker != null) {
                const coords = marker.getLatLng();
                SetAnswerValue(JSON.stringify({ latitude: coords.lat, longitude: coords.lng }))
            }
        },
    };

    const SetValueNumberFunction = (e: string) => SetAnswerValue(e);

    const getBase64 = (file: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => SetAnswerValue(JSON.stringify({ 
            base64: (reader.result as string).split('base64,')[1], 
            uri: 'none', 
            type: file.type, 
            name: file.name }));
        SetRespuestaFile(file.name);
        reader.onerror = error => console.log(error);
    };

    const handAsignOption = () => {
        if (question?.preguntaTipoNombre == PreguntaTipo.Fecha || question?.preguntaTipoNombre == PreguntaTipo.FechaHora || question?.preguntaTipoNombre == PreguntaTipo.Hora)
        {
            setRespuestaFecha(!!answerValue ? answerValue : !!defaultValue ? defaultValue : null);
            setMinFecha(!!question?.valorMinimo ? question?.valorMinimo : null);
            setMaxFecha(!!question?.valorMaximo ? question?.valorMaximo : null);
        } 
        if (question?.preguntaTipoNombre == PreguntaTipo.Seleccion)
        {
            const _listOptions: { label: string, value: string }[] = [];
            question?.respuestaOpcion.forEach((detail: any) => {
                _listOptions.push({ ..._listOptions, label: detail.respuesta!, value: detail.respuesta! })
            });
            SetRespuestaOpciones(_listOptions)

        } 
        else if (question?.preguntaTipoNombre == PreguntaTipo.SeleccionMultiple)
        {
            const _listOptionsMulti: { label: string, value: string }[] = [];
            question?.respuestaOpcion.forEach((detail: any) => {
                _listOptionsMulti.push({ ..._listOptionsMulti, label: detail.respuesta!, value: detail.respuesta! })
            });
            SetRespuestaOpcionesMultiple(_listOptionsMulti)

        }
        else if (question?.preguntaTipoNombre == PreguntaTipo.Archivo)
        {
            SetRespuestaFile("");
            var json = null;
            if (question?.respuestaOpcion != null && question?.respuestaOpcion.length > 0 && question?.respuestaOpcion[0].respuesta != null && question?.respuestaOpcion[0].respuesta != "")
            {
                json = question?.respuestaOpcion[0].respuesta;
            }
            else if (answerValue != null && answerValue != "")
            {
                json = answerValue;
            }
            if (json != null) {
                try {
                    const parsedValue = JSON.parse(json)
                    SetRespuestaFile(parsedValue.name);
                } catch (e) {
                    SetRespuestaFile("");
                }
            }

        }
        else if (question?.preguntaTipoNombre == PreguntaTipo.FechaRangoMultiple)
        {

            if (answerValue != null && answerValue != "" )
            {
                
                const valorRespuesta = answerValue != null ? answerValue : defaultValue != null ? defaultValue : '';
                const _listMultiDate: { fechaDesde: string, fechaHasta: string }[] = [];
                const ranges: DateRanges = [];

                valorRespuesta.split("|").map((valor: any) => {
                    const parsedValue = JSON.parse(valor)
                    _listMultiDate.push({ fechaDesde: parsedValue.fechaDesde, fechaHasta: parsedValue.fechaHasta })
                    ranges.push([new DateObject(parsedValue.fechaDesde), new DateObject(parsedValue.fechaHasta)]);
                })

                setListRespuestaFechaRangoMultiple(_listMultiDate);
                setRespuestaFechaRangoMultiple(ranges);
                
            } 
            else if (defaultValue != null && defaultValue != "" )
            {
                
                const parsedValue = JSON.parse(answerValue != null ? answerValue : defaultValue != null ? defaultValue : '');
                setRespuestaFechaRango([new DateObject(parsedValue.fechaDesde), new DateObject(parsedValue.fechaHasta)]);
                setObjectRespuestaFechaRango({ fechaDesde: parsedValue.fechaDesde, fechaHasta: parsedValue.fechaHasta });                
                
            }
            
            setMinFecha(!!question?.valorMinimo ? question?.valorMinimo : null);
            setMaxFecha(!!question?.valorMaximo ? question?.valorMaximo : null);
        } 
        else if (question?.preguntaTipoNombre == PreguntaTipo.FechaRango)
        {
            if ((answerValue != null && answerValue != "" ) || (defaultValue != null && defaultValue != "" ))
            {

                const parsedValue = JSON.parse(answerValue != null ? answerValue : defaultValue != null ? defaultValue : '');
                setRespuestaFechaRango([new DateObject(parsedValue.fechaDesde), new DateObject(parsedValue.fechaHasta)]);
                setObjectRespuestaFechaRango({ fechaDesde: parsedValue.fechaDesde, fechaHasta: parsedValue.fechaHasta });
            }    
            
            setMinFecha(!!question?.valorMinimo ? question?.valorMinimo : null);
            setMaxFecha(!!question?.valorMaximo ? question?.valorMaximo : null);
        }
    }

    const OptionSelectedHand = (valor: any) => {
        const respuestaSelecionada = question?.respuestaOpcion.find((x: any) => x.respuesta == valor.target.value);
        handleOptiont(respuestaSelecionada?.respuesta!);
        setOptionSelected(respuestaSelecionada);
        if (respuestaSelecionada?.preguntaSiguienteID == null) {
            setIsLastQuestion?.(true);
        } else {
            setIsLastQuestion?.(false);
            setActive?.(true);
        }
    }

    // Funtions handleOnChanges
    const handleTextBox = (event: any) => { SetAnswerValue(event.target.value) } //Text

    const handleDateBox = (date: any, dateString: any) => {   
        SetAnswerValue(null); 
        setRespuestaFecha(null);
        const dates =  dateString.validatedValue;
        
        if (dates.length > 0) {
            setRespuestaFecha(moment(dates[0]).format('YYYY-MM-DD'));
            SetAnswerValue(moment(dates[0]).format('YYYY-MM-DD'));
        }
    } // Date

    const handleDateHourBox = (date: any, dateString: any) => {   
        SetAnswerValue(null); 
        setRespuestaFecha(null);
        const dates =  dateString.validatedValue;
        
        if (dates.length > 0) {
            setRespuestaFecha(moment(dates[0]).format('YYYY-MM-DD HH:mm:ss'));
            SetAnswerValue(moment(dates[0]).format('YYYY-MM-DD HH:mm:ss'));
        }
    } //Date & Hour

    const handleHourBox = (date: any, dateString: any) => {   
        SetAnswerValue(null); 
        setRespuestaFecha(null);
        const dates =  dateString.validatedValue;
        
        if (dates.length > 0) {
            setRespuestaFecha(dates[0].toString());
            SetAnswerValue(dates[0].toString());
        }
    }; //Date & Hour

    const handleOptiont = (text: string) => { SetAnswerValue(text); }  //Option

    const handleSelect = (text: any) => SetAnswerValue(!!text ? text.join('|').toString() : ''); //Select

    const handleClick = () => setShowMap(!showMap);

    const handleMultiDateBox = (date: any, dateString: any) => {        
        const dates = dateString.validatedValue.split(',').map((str: any) => str.trim());
        const listDateRanges: DateRanges = [];

        const listMultiDate = dates.map((range: any) => {
            const dates = range.split(' ~ ').map((date: any) => date.trim());
        
            if (dates.length === 2) {
                // Es un rango de fechas
                const [startDateStr, endDateStr] = dates;
                listDateRanges.push(dates);

                return {
                    fechaDesde: moment(startDateStr).format('YYYY-MM-DD'),
                    fechaHasta: moment(endDateStr).format('YYYY-MM-DD')
                };
            } else if (dates.length === 1) {
                // Es una fecha individual
                const singleDateStr = dates[0];
                const date = moment(singleDateStr).format('YYYY-MM-DD');
                listDateRanges.push(dates);

                return {
                    fechaDesde: date,
                    fechaHasta: date
                };
            }
        });
        
        const dateMultipleRangeString = listMultiDate.map((range: any) => JSON.stringify(range)).join('|').toString();
        
        setListRespuestaFechaRangoMultiple(listMultiDate);
        setRespuestaFechaRangoMultiple(listDateRanges);
        SetAnswerValue(dateMultipleRangeString);

     } // Date

     const handleFechaRangoBox = (date: any, dateString: any) => {        
        let rangeDate: { fechaDesde: string, fechaHasta: string } = {fechaDesde: "", fechaHasta: ""};
        const dates =  dateString.validatedValue;
        
        if (dates.length === 2) {
            // Es un rango de fechas
            const [startDateStr, endDateStr] = dates;
            rangeDate = {
                fechaDesde: moment(startDateStr).format('YYYY-MM-DD'),
                fechaHasta: moment(endDateStr).format('YYYY-MM-DD')
            };
        } else if (dates.length === 1) {
            // Es una fecha individual
            const singleDateStr = dates[0];
            const date = moment(singleDateStr).format('YYYY-MM-DD');
            rangeDate = {
                fechaDesde: date,
                fechaHasta: date
            };
        }
    
        setObjectRespuestaFechaRango(rangeDate);
        setRespuestaFechaRango(date);
        SetAnswerValue(JSON.stringify(rangeDate));

     } // Date

     const handleClearDate = () => {
        setRespuestaFecha(null);
        SetAnswerValue(null);
     }

     const handleClearRangeDate = () => {
        let rangeDate: { fechaDesde: string, fechaHasta: string } = {fechaDesde: "", fechaHasta: ""};
        setObjectRespuestaFechaRango(rangeDate);
        setRespuestaFechaRango(undefined);
        SetAnswerValue(null);
     }

     const handleClearMultiRangeDate = (fechaDesde: string, fechaHasta: string) => {
         
        const listMultiDate: { fechaDesde: string, fechaHasta: string }[] = [];
        const listDateRanges: DateRanges = [];

        listRespuestaFechaRangoMultiple.forEach((detail: any) => {
            if (detail.fechaDesde != fechaDesde && detail.fechaHasta != fechaHasta)
            {
                listMultiDate.push({ fechaDesde: detail.fechaDesde, fechaHasta: detail.fechaHasta })
                listDateRanges.push([new DateObject(detail.fechaDesde), new DateObject(detail.fechaHasta)]);
            }                
        });

        const dateRangeString = listMultiDate.map((range: any) => JSON.stringify(range)).join('|').toString();

        setListRespuestaFechaRangoMultiple(listMultiDate);
        setRespuestaFechaRangoMultiple(listDateRanges);
        SetAnswerValue(dateRangeString);

     }
      
     const getDateFromTimeString = (timeString: string): Date => {
        const [hours, minutes, seconds] = timeString.split(':').map(Number);
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);
    };

    const renderSwitch = () => {
        switch (value) {
            case PreguntaTipo.Texto:
                typeInput =
                    <input type="text" readOnly={active} defaultValue={defaultValue} className='textBox' id='text211' placeholder={!!active ? "" : "Escribir respuesta aca..."} value={!!answerValue || !!defaultValue ? answerValue : ''} onChange={handleTextBox}></input>
                break;
            case PreguntaTipo.Numerico:
                typeInput =
                    <input type="text" readOnly={active} defaultValue={defaultValue} className='textBox' pattern="[0-9]+([\.])?[0-9]*" placeholder={!!active ? "" : 'Responder con un número..'} value={(!!answerValue || !!defaultValue) ? answerValue : ''} onChange={(e) => e.target.validity.valid ? SetValueNumberFunction(e.target.value.toString()) : null}></input>
                break;
            case PreguntaTipo.Galeria:    
            case PreguntaTipo.CamaraGaleria:
            case PreguntaTipo.Imagen:
                typeInput =
                    <div className='image-container'>
                        <div className="upload-photoCase">
                            {(!!answerValue || !!photoPreview)
                                ? <img src={`data:image/png;base64,${JSON.parse(!answerValue ? photoPreview : answerValue)?.base64}`} className="viewer-photo" alt="Foto de perfil" />
                                : <Upload
                                    listType="picture-card"
                                    fileList={[]}
                                    beforeUpload={getBase64} className="button-upload-image">
                                    <CameraFilled className="icon-Upload-camera" />
                                </Upload>
                            }
                            {
                                !active && <div className="icon-delete-camera" onClick={() => { SetAnswerValue(''); setPhotoPreview('') }}> <i className="fa-solid fa-trash"></i>
                                </div>
                            }

                        </div>
                    </div>;
                break;
            case PreguntaTipo.Fecha:
                typeInput =
                    <div>
                        <DatePicker 
                            placeholder={!!active ? "" : "Selecionar una fecha"}                            
                            value={!!respuestaFecha ? new DateObject(respuestaFecha) : null}
                            onChange={handleDateBox}
                            format="YYYY-MM-DD"
                            disabled={active}
                            editable={false}
                            minDate={!!minFecha ? new Date(minFecha) : undefined}
                            maxDate={!!maxFecha ? new Date(maxFecha) : undefined}
                            inputClass="textBoxDatePicker"
                        />
                        <button type="button" hidden={active} className="cerrarmapabutton" onClick={() => { handleClearDate(); }}><CloseOutlined /></button>
                    </div>
                break;
            case PreguntaTipo.FechaHora:
                typeInput =
                    <div>   
                        <DatePicker 
                            placeholder={!!active ? "" : 'Selecionar una fecha y una hora'}
                            value={!!respuestaFecha ? new Date(respuestaFecha) : null}  
                            onChange={handleDateHourBox}
                            format="YYYY-MM-DD HH:mm:ss"
                            plugins={[ <TimePicker position="bottom" /> ]} 
                            disabled={active}
                            editable={false}
                            minDate={!!minFecha ? new Date(minFecha) : undefined}
                            maxDate={!!maxFecha ? new Date(maxFecha) : undefined}
                            inputClass="textBoxDatePicker"
                        />
                        <button type="button" hidden={active} className="cerrarmapabutton" onClick={() => { handleClearDate(); }}><CloseOutlined /></button>
                    </div>
                break;
            case PreguntaTipo.Hora:
                typeInput =
                    <div>  
                        <DatePicker 
                            placeholder={!!active ? "" : 'Selecionar una hora'}
                            value={!!respuestaFecha ? getDateFromTimeString(respuestaFecha) : null}
                            onChange={handleHourBox}
                            disableDayPicker
                            format="HH:mm:ss"
                            plugins={[ <TimePicker /> ]}                        
                            disabled={active}
                            editable={false}
                            minDate={!!minFecha ? new Date(minFecha) : undefined}
                            maxDate={!!maxFecha ? new Date(maxFecha) : undefined}
                            inputClass="textBoxDatePicker"
                        />
                        <button type="button" hidden={active} className="cerrarmapabutton" onClick={() => { handleClearDate(); }}><CloseOutlined /></button>
                    </div>
                break;
            case PreguntaTipo.Seleccion:
                typeInput = (
                <div style={{ 
                    maxHeight: '40.625rem',
                     overflowY: 'auto'
                     }}>
                    <Radio.Group className="Radio-group"
                    value={answerValue}
                    options={respuestaOpciones}
                    onChange={(value: any) => OptionSelectedHand(value)}
                    optionType="button"
                    buttonStyle="solid"
                />
                </div>)
                break;
            case PreguntaTipo.SeleccionMultiple:
                typeInput =
                    <Select
                        mode="multiple"
                        defaultValue={!!answerValue ? answerValue.split('|') : []}
                        value={!!answerValue ? answerValue.split('|') : []}
                        style={{
                            width: '100%',
                        }}
                        placeholder="Selecionar respuestas"
                        onChange={handleSelect}
                        optionLabelProp="label"
                    >
                        {respuestaOpcionesMultiple.map(option =>
                            <Option value={option.value} key={option.label} label={option.label}>
                                <div className="demo-option-label-item">
                                    <span role="img" aria-label="China"> </span>
                                    {option.value}
                                </div>
                            </Option>)}

                    </Select>
                break;
            case PreguntaTipo.Coordenadas:
                typeInput =
                    <div className='mapbox'>
                        {showMap ?
                            <div className='map'>
                                <MapContainer center={position} zoom={15} scrollWheelZoom={false}>
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker
                                        position={position}
                                        draggable={isDraggable ? true : false}
                                        eventHandlers={eventHandlers}
                                        ref={markerRef}>
                                    </Marker>
                                    <ChangeCenter coords={position} />
                                </MapContainer>
                                <div className='boxlatlng'>
                                    <label htmlFor="latitud">Latitud</label>
                                    <input id="latitud" readOnly={active} className='textBoxCoord' value={position.lat} disabled={true}></input>
                                    <label htmlFor="longitud">Longitud</label>
                                    <input id="longitud" readOnly={active} className='textBoxCoord' value={position.lng} disabled={true}></input>
                                    <button type="button"  className="cerrarmapabutton" onClick={handleClick}><CloseOutlined /></button>
                                </div>
                            </div>
                            :
                            <div className="buttondiv">
                                <LoadingButton
                                    type="button"
                                    title={"Abrir Mapa"}
                                    style={{ height: '3.125rem', width: '20rem' }}
                                    background={COLORS.blue_active}
                                    color={COLORS.white_color1}
                                    method ={handleClick}
                                    loading={""}
                                    fontsize={18}
                                />
                            </div>
                        }
                    </div>
                break;
            case PreguntaTipo.Archivo:                
                {!active 
                ?  typeInput =
                    <InputWrapper value={(!!respuestaFile).toString()}>
                        <label>{!!respuestaFile ? respuestaFile : "Elegir archivo"}</label>
                        <div className="group-icon">
                            {!!respuestaFile
                            ? <nav className="icon-remove" onClick={() => { SetAnswerValue(''); SetRespuestaFile('') }}><i className="fa-solid fa-xmark"></i></nav>
                            : <nav>
                                <Upload
                                    listType="picture-card"
                                    fileList={[]}
                                    beforeUpload={getBase64}
                                    className="icon-upload"
                                >
                                    <i className="fa-solid fa-upload"></i>
                                </Upload>
                            </nav>
                            }
                        </div>
                    </InputWrapper>
                :
                typeInput =
                    <input type="text" readOnly={active} className='textBox' id='textArchivo' value={respuestaFile || undefined}></input>
                }
                break;
            case PreguntaTipo.FechaRango:
                typeInput =
                    <div>
                        {!active ?
                            <div>
                                <DatePicker 
                                    placeholder='Seleccionar el rango de fecha'
                                    value={respuestaFechaRango}
                                    onChange={handleFechaRangoBox} 
                                    range
                                    disabled={active}
                                    editable={false}
                                    format="YYYY-MM-DD"
                                    minDate={!!minFecha ? new DateObject(minFecha) : undefined}
                                    maxDate={!!maxFecha ? new DateObject(maxFecha) : undefined}
                                    inputClass="textBoxDatePicker"
                                />
                                <button type="button" hidden={active} className="cerrarmapabutton" onClick={() => { handleClearRangeDate(); }}><CloseOutlined /></button>
                            </div>
                            
                        :
                        <div className='boxlatlng'>
                            <label htmlFor="latitud">Fecha Desde</label>
                            <input id="latitud" readOnly={active} className='textBoxCoord' value={objectRespuestaFechaRango.fechaDesde || undefined} disabled={true}></input>
                            <label htmlFor="longitud">Fecha Hasta</label>
                            <input id="longitud" readOnly={active} className='textBoxCoord' value={objectRespuestaFechaRango.fechaHasta || undefined} disabled={true}></input>
                        </div>
                        }
                    </div>           
                break;
            case PreguntaTipo.FechaRangoMultiple:
                typeInput =
                    <div>
                        {!active ?
                            <DatePicker 
                                value={respuestaFechaRangoMultiple}
                                onChange={handleMultiDateBox} 
                                multiple 
                                range 
                                minDate={!!minFecha ? new DateObject(minFecha) : undefined}
                                maxDate={!!maxFecha ? new DateObject(maxFecha) : undefined}
                                render={<Icon/>}
                            />
                            :
                            <div></div>
                        }
                        <div style={{maxHeight: '20.625rem', overflowY: 'auto'}}>
                            {listRespuestaFechaRangoMultiple.map((dateRange, index) => (
                                <div key={index} className='boxlatlng'>
                                    <label htmlFor="latitud">Fecha Desde</label>
                                    <input id="latitud" readOnly={active} className='textBoxCoord' value={dateRange.fechaDesde} disabled={true}></input>
                                    <label htmlFor="longitud">Fecha Hasta</label>
                                    <input id="longitud" readOnly={active} className='textBoxCoord' value={dateRange.fechaHasta} disabled={true}></input>
                                    <button type="button" hidden={active} className="cerrarmapabutton" onClick={() => { handleClearMultiRangeDate(dateRange.fechaDesde, dateRange.fechaHasta); }}><CloseOutlined /></button>
                                </div>
                            ))}                        
                        </div>        
                    </div>           
                break;
            default:
                typeInput = <></>
                break;
        }
        return typeInput;
    }

    useEffect(() => {
        SetQuestion(item);
    }, [item]);

    useEffect(() => {
        handAsignOption();
        setPhotoPreview(defaultValue);
    }, [question]);

    // useEffect(() => {
    //     if (showMap === true && center !== position) {
    //         SetAnswerValue(JSON.stringify({ latitude: position.lat, longitude: position.lng }))
    //         console.log(position, ".")
    //     }
    // }, [position])

    const handleCoords = (coordsParam: any) => {
        if (!!coordsParam) {
            const coord = JSON.parse(coordsParam);
            setPosition({ lat: coord?.latitude, lng: coord?.longitude });
        } else {
            setPosition(center);
        }
    }

    useEffect(() => {
        if (value === PreguntaTipo.Coordenadas) {
            //console.log("use effect");
            if (!!defaultValue && !answerValue) {
                handleCoords(defaultValue);
            } else if (answerValue) {
                handleCoords(answerValue);
            }
        }
    }, [defaultValue, answerValue])

    return renderSwitch();
}
export default TypeInputGeneratorItem;
